import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { TaxEvidenceInfo } from '../fragments';

export default gql`
  mutation ActionTaxEvidenceStatus($input: TaxEvidenceStatusActionInput!) {
    actionTaxEvidenceStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      taxEvidence {
        ...TaxEvidenceInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${TaxEvidenceInfo}
`;
